import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { InstructionsIndex } from './printing/instructionsTypes';

export const instructionEndpoints = (
  builder: EndpointBuilder<any, any, any>,
) => ({
  getInstructionsIndex: builder.query<InstructionsIndex, void>({
    query: () => ({
      url: '/part-order/instructions-to-print/',
      method: 'GET',
    }),
  }),
});

export const resolveUrls = (index: InstructionsIndex, baseUrl?: string): string[] => {
  const urls: string[] = [];
  
  for (const item of index) {
    for (const file of item.instructionFiles) {
      // If file starts with /, it's an absolute path, prepend baseUrl
      const url = file.startsWith('/') 
        ? `${baseUrl || ''}${file}` 
        : file;
      urls.push(url);
    }
  }
  
  return [...new Set(urls)]; // Remove duplicates
};
